export default __webpack_public_path__ + "static/media/CCCert.379d0fb0.pdf";